// UI strings for Illan tie live on two phones (Axel 2026-10-25, together/evening/live.ts): the student's phone in
// Opettaja ja oppilas follows the teacher's item and shows the grade once tapped.
import { defineArea } from '../area';

export const eveningLiveFi = {
  /** The student's phone before the teacher taps a grade. */
  gradeWait: 'Odottaa arviota',
  /** Before the tapped grade: "Arvio: Oikein". */
  grade: 'Arvio',
  /** The line being read now (screen readers). */
  now: 'Luetaan nyt',
};

export type EveningLiveMessages = typeof eveningLiveFi;

export const eveningLiveEn: EveningLiveMessages = {
  gradeWait: 'Waiting for the grade',
  grade: 'Grade',
  now: 'Being read now',
};

// Messages.eveningLive (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('eveningLive', eveningLiveFi, eveningLiveEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof eveningLiveFi> {}
}
